$ = window.jQuery;

if (window.location.href.indexOf('no_prices') != -1) {
  $('.main-header, footer, .activity-container .sidebar').remove();
}

$(() => {
  $(document).trigger('dom-update');
});


$(document).mouseup(function (e) {
  var $container = $('[data-out]:visible'),
    $trigger = $('[href="#' + $container.attr('id') + '"]');

  if (!$container.is(e.target) // if the target of the click isn't the container...
    && +$container.css('opacity') === 1
    && !$trigger.is(e.target)
    && !$(e.target).hasClass('main-menu-button')
    && !$(e.target).closest('.main-menu-button').length
    && $container.has(e.target).length === 0) // ... nor a descendant of the container)
  {
    if ($container.attr('id') === "main-menu") {
      $('.main-menu-button').trigger('click');
    } else {
      $container.hide();
    }
  }
})

$(document).on('click', '[data-to]', (e) => {
  e.preventDefault();
  const hash = e.target.hash;
  const $cnt = $(hash);
  let compensation = 70;
  if (MQBE.current_state() === 'mobile' && hash === '#reviews') {
    $cnt.closest('.b-card-block').addClass('active');
    compensation += 45;
  }
  $('html, body').animate({
    scrollTop: $cnt.offset().top - compensation
  }, 500);
});


if (document.readyState == 'complete') {
  if (window.jQuery) window.jQuery('.guide-container .content, .activity-container .content').trigger('dom-update');
  if (window.jQuery && window.Buendia) {
    jQuery('.b-cdo-picture-slider.slim').removeClass('slim');
  }
} else {
  window.addEventListener('load', function () {
    if (window.jQuery) window.jQuery('.guide-container .content, .activity-container .content').trigger('dom-update');
    if (window.jQuery && window.Buendia) {
      jQuery('.b-cdo-picture-slider.slim').removeClass('slim');
    }
  }, false);
}


window.addEventListener('beforeunload', function (event) {
  if (event.state) {
    event.preventDefault();
  }
});


// $(document).on('footer_showed', function () {
// $("div.pre-footer, footer *").each(function(){
//   $(this).css("visibility", "visible");
// });
//   $("footer *").each(function () {
//     $(this).css("visibility", "visible");
//   });
// });


// $(document).ready(function () {
//   var interval = 0;
//   var delay = 300;
//   $("main#main-content > div > div:not(.scroll-to-top):not(.search-results), footer").each(function () {
//     var $element = $(this);
//     if ($element.prop('nodeName') === "FOOTER") {
//       setTimeout(function () {
//         $element.css('visibility', 'visible');
//         $(document).trigger('footer_showed');
//       }, delay * interval);
//     } else {
//       setTimeout(function () {
//         $element.fadeIn(delay);
//       }, delay * interval);
//     }
//     interval++;
//   });
// });

